import { Injectable, Type } from '@angular/core';
import { AccessRightFormComponent } from '../components/forms/access-right-form/access-right-form.component';
import { AssetFormComponent } from '../components/forms/asset-form.component';
import { AssetGroupFormComponent } from '../components/forms/asset-group-form.component';
import { AssetTypeFormComponent } from '../components/forms/asset-type-form.component';
import { AuscultationInformationFormComponent } from '../components/forms/auscultation-information-form.component';
import { ChoiceListElementFormComponent } from '../components/forms/choice-list-element-form.component';
import { ChoiceListFormComponent } from '../components/forms/choice-list-form.component';
import { FormulaModelFormComponent } from '../components/forms/formula-model-form.component';
import { LocationFormComponent } from '../components/forms/location-form.component';
import { MeasureCheckerFormComponent } from '../components/forms/measure-checker-form.component';
import { MeasureFormulaFormComponent } from '../components/forms/measure-formula-form.component';
import { MeasureTypeFormComponent } from '../components/forms/measure-type-form.component';
import { UnitFormComponent } from '../components/forms/unit-form/unit-form.component';
import { GenericEntityFormComponent } from '../components/generic/generic-entity-form.component';

@Injectable({
  providedIn: 'root',
})
export class FormRegistryService {
  private readonly componentRegistry = new Map<string, Type<unknown>>();

  constructor() {
    this.initializeRegistry();
  }

  private initializeRegistry(): void {
    this.componentRegistry.set('Asset', AssetFormComponent);
    this.componentRegistry.set('AssetGroup', AssetGroupFormComponent);
    this.componentRegistry.set('AssetType', AssetTypeFormComponent);
    this.componentRegistry.set('AuscultationInformation', AuscultationInformationFormComponent);
    this.componentRegistry.set('Campaign', GenericEntityFormComponent);
    this.componentRegistry.set('ChoiceList', ChoiceListFormComponent);
    this.componentRegistry.set('ChoiceListElement', ChoiceListElementFormComponent);
    this.componentRegistry.set('default', GenericEntityFormComponent);
    this.componentRegistry.set('FormulaModel', FormulaModelFormComponent);
    this.componentRegistry.set('Location', LocationFormComponent);
    this.componentRegistry.set('MeasureChecker', MeasureCheckerFormComponent);
    this.componentRegistry.set('MeasureFormula', MeasureFormulaFormComponent);
    this.componentRegistry.set('MeasureType', MeasureTypeFormComponent);
    this.componentRegistry.set('PolynomialModel', FormulaModelFormComponent);
    this.componentRegistry.set('Unit', UnitFormComponent);
    this.componentRegistry.set('AccessRightDomain', AccessRightFormComponent);
  }

  getFormComponentForEntity(entityType: string): Type<unknown> {
    const component = this.componentRegistry.get(entityType);
    if (!component) {
      console.info('FormRegistryService: using default form instead of', entityType);
      return GenericEntityFormComponent;
    }
    return component;
  }
}
